<template>
  <FlexCol gap-1 class="relative" ref="triggerRef">
    <Label :label="label" :required="required" :error="error" />
    <Input v-model="displayValue" :error="error" placeholder="Selecione o mês" :disabled="disabled" readonly>
      <template #pos-icon>
        <IconInput icon="fa-xmark" class="border-l" @click="clear" v-if="displayValue" />
        <IconInput icon="fa-calendar-days" @click="toggle" class="border-l" />
      </template>
    </Input>
    <Error :message="error" />

    <Teleport to="body">
      <div v-if="open" :style="popupStyle" class="fixed z-[2000]">
        <CalendarMonth :range="props.range" v-model="month" />
      </div>
    </Teleport>
  </FlexCol>
</template>

<script setup>
import {ref, watch, onMounted, onBeforeUnmount, nextTick} from "vue"
import {useFormat} from "@/composables/useFormat"

const {formatIsoDatetime} = useFormat()

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [Array, String],
  range: Boolean,
})

const emits = defineEmits(["update:modelValue"])

const open = ref(false)
const error = ref(props.error)
const month = ref(null)
const displayValue = ref("")
const triggerRef = ref(null)
const popupStyle = ref({})

const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

const toggle = () => {
  if (!props.disabled) {
    open.value = !open.value
    if (open.value) {
      nextTick(updatePopupPosition)
    }
  }
}

const clear = () => {
  month.value = null
  displayValue.value = ""
  emits("update:modelValue", [])
  open.value = false
}

const getMonthRange = (yearMonth) => {
  const [year, month] = yearMonth.split("-").map(Number)
  const startDate = new Date(year, month - 1, 1)
  const endDate = new Date(year, month, 0)

  startDate.setHours(0, 0, 0, 0)
  endDate.setHours(23, 59, 59, 999)

  return [formatIsoDatetime(startDate), formatIsoDatetime(endDate)]
}

const updatePopupPosition = () => {
  const triggerElement = triggerRef.value?.$el ?? triggerRef.value
  if (!open.value || !triggerElement || typeof triggerElement.getBoundingClientRect !== "function") return
  const rect = triggerElement.getBoundingClientRect()
  popupStyle.value = {
    top: `${rect.bottom + 8}px`,
    left: `${rect.left}px`,
    width: `${rect.width}px`,
  }
}
const formatDisplayRange = (startDateTime, endDateTime) => {
  if (!startDateTime || !endDateTime) {
    return ""
  }

  const [startY, startM] = startDateTime.split(" ")[0].split("-").map(Number)
  const [endY, endM] = endDateTime.split(" ")[0].split("-").map(Number)
  const startName = monthNames[startM - 1]
  const endName = monthNames[endM - 1]

  if (startY !== endY) {
    return `${startName} ${startY} - ${endName} ${endY}`
  }
  if (startName === endName) {
    return `${startName} ${startY}`
  }
  return `${startName} - ${endName} ${startY}`
}

// atualiza quando o usuário seleciona um mês
watch(month, (newValue) => {
  if (!newValue) return

  if (!props.range) {
    console.log("if?")

    const [year, m] = newValue.split("-").map(Number)
    displayValue.value = `${monthNames[m - 1]} ${year}`

    const range = getMonthRange(newValue)
    emits("update:modelValue", range)
  }
  if (props.range) {
    displayValue.value = formatDisplayRange(newValue[0], newValue[1])
    emits("update:modelValue", newValue)
  }
  open.value = false
})

// sincroniza quando modelValue vem de fora
watch(
  () => props.modelValue,
  (newValue) => {
    if (!newValue || newValue.length < 2) return
    if (!props.range) {
      const start = new Date(newValue[0])
      const monthIndex = start.getMonth()
      const year = start.getFullYear()
      displayValue.value = `${monthNames[monthIndex]} ${year}`
    }
  },
  {immediate: true}
)
// sincroniza erro
watch(
  () => props.error,
  (newValue) => (error.value = newValue)
)

watch(open, (isOpen) => {
  if (isOpen) {
    nextTick(updatePopupPosition)
  }
})

onMounted(() => {
  window.addEventListener("resize", updatePopupPosition)
  window.addEventListener("scroll", updatePopupPosition, true)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updatePopupPosition)
  window.removeEventListener("scroll", updatePopupPosition, true)
})
</script>
